import { render } from "./Devtool.vue?vue&type=template&id=1e4024fe"
import script from "./Devtool.vue?vue&type=script&lang=js"
export * from "./Devtool.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__